import { Text, TextType } from 'ui-components/components/text';

import { CustomsField } from '../customs-field';
import { DescriptionInput } from './description-input';
import { messages } from '../messages';
import { useIntl } from 'react-intl';

type CustomsDescriptionProps = {
  value?: string;
  onChange: (value: string) => void;
};

export const CustomsDescription = ({ onChange, value = '' }: CustomsDescriptionProps) => {
  const intl = useIntl();

  const handleChange = (updatedValue: string | number) => {
    onChange(String(updatedValue));
  };

  return (
    <CustomsField label={messages.descriptionLabel} required>
      <DescriptionInput aria-label={intl.formatMessage(messages.descriptionLabel)} onChange={handleChange} value={value} />
      <Text textType={TextType.Caption} value={messages.descriptionHelperText} />
    </CustomsField>
  );
};
